<template>
  <ul class="site-social" :class="classes">
    <template v-for="account in socialAccountsSorted">
      <li :key="account._id.$oid" v-if="account.url">
        <SocialAccount
          :account="account"
          :campsite="campsite"
          :isFreePlan="isFreePlan"
        />
      </li>
    </template>
  </ul>
</template>

<script>
import SocialAccount from './social-account';

export default {
  components: {
    SocialAccount,
  },

  props: {
    isTop: Boolean,
    socialAccounts: Array,
    campsite: Object,
    isFreePlan: Boolean,
  },

  computed: {
    socialAccountsSorted() {
      return [...this.socialAccounts].sort((a, b) => a.position - b.position);
    },

    classes() {
      return {
        'site-social--top': this.isTop,
      };
    },
  },
};
</script>

<style lang="scss">
.site-social {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  justify-content: center;
  position: relative;
  margin: 18px 0 0;
  padding: 0;

  &--top {
    margin-bottom: -8px;
    margin-top: 10px;
  }

  > li {
    margin: 3px 7px;
  }
}

.site-social a {
  color: var(--p-social-color);
  display: inline-flex;
  font-size: 30px;
  padding: 6px;
  vertical-align: top;
  transition: transform var(--g-transition-speed) cubic-bezier(0.4, 0, 0.2, 1);

  &:hover,
  &:focus {
    color: var(--p-social-color);
    transform: scale(1.1);
  }

  .v-svg-icon {
    flex-shrink: 0;
  }
}
</style>
